var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 473.151,
    height: 603.459,
    viewBox: "0 0 473.151 603.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_256_personal_data_flatline",
    "data-name": " 256 personal data flatline",
    transform: "translate(-111.6 -21.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9848",
    "data-name": "Trazado 9848",
    d: "M149.716,326.87c-4.54,40.717-17.289,95.054-23.146,115.4h59.558l36.53-4.422s8.468-79.388,13.784-96.771,1.2-183.239,1.364-184.909-89.5,39.047-98.441,77.812C135.908,249.082,151.245,313.133,149.716,326.87Z",
    transform: "translate(20.243 181.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9849",
    "data-name": "Trazado 9849",
    d: "M127.244,444.189a1.134,1.134,0,0,1-.941-.47,1.22,1.22,0,0,1-.188-1.035c5.834-20.323,18.63-74.989,23.1-115.259h0c.659-5.928-2-21.993-4.7-38.976-3.693-22.323-7.5-45.4-5.5-54.1,8.586-37.353,93.877-78.776,99.57-78.776h0a1.248,1.248,0,0,1,1.035,1.317c0,.353,0,4.846.188,11.055.729,39.376,2.94,159.175-1.6,174.065-5.2,17.077-13.643,95.736-13.714,96.441a1.175,1.175,0,0,1-1.035,1.035l-36.389,4.7Zm1.552-2.352H186.8l35.542-4.3c1.011-9.409,8.7-79.576,13.737-96.065,2.94-9.644,3.434-67.956,1.482-173.336,0-5.34-.141-8.209-.165-9.738-10.8,4.022-87.832,40.694-96.112,76.612-1.882,8.162,2.07,32.037,5.551,53.09,2.823,17.171,5.5,33.4,4.7,39.635h0C147.073,367.153,134.841,420.361,128.8,441.836Z",
    transform: "translate(19.569 180.993)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9850",
    "data-name": "Trazado 9850",
    d: "M125.9,272.23l5.292-35.26,107.873,18.982-4.352,38.106Z",
    transform: "translate(19.337 291.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9851",
    "data-name": "Trazado 9851",
    d: "M235.419,295.92h-.235L126.346,274.091a1.224,1.224,0,0,1-.941-1.341l5.316-35.283a1.182,1.182,0,0,1,.47-.776,1.2,1.2,0,0,1,.894-.212l107.85,19.006a1.153,1.153,0,0,1,.964,1.27l-4.328,38.13a1.2,1.2,0,0,1-.47.823A1.223,1.223,0,0,1,235.419,295.92ZM127.9,271.974l106.485,21.382,4.069-35.754L132.862,239.019Z",
    transform: "translate(18.655 290.379)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9852",
    "data-name": "Trazado 9852",
    d: "M254.069,322.691l2.305-54.007L133.259,244.55,116.84,322.691Z",
    transform: "translate(7.086 301.314)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9853",
    "data-name": "Trazado 9853",
    d: "M254.744,324.547H117.515a1.172,1.172,0,0,1-.917-.423,1.247,1.247,0,0,1-.235-.988l16.466-78.141a1.129,1.129,0,0,1,1.3-.931l.066.014,123.139,24.134a1.13,1.13,0,0,1,.941,1.2l-2.352,54.1A1.2,1.2,0,0,1,254.744,324.547Zm-135.771-2.352H253.615l2.352-51.89-121-23.71Z",
    transform: "translate(6.411 300.635)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2001",
    "data-name": "Rect\\xE1ngulo 2001",
    width: 337.551,
    height: 448.32,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 112.682, 139.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9854",
    "data-name": "Trazado 9854",
    d: "M266.259,561.036a1.2,1.2,0,0,1-1.106-.753L111.67,138.881a1.176,1.176,0,0,1,.706-1.505L429.692,21.811a1.176,1.176,0,0,1,.894,0,1.252,1.252,0,0,1,.612.682l153.483,421.4a1.176,1.176,0,0,1-.706,1.505L266.659,561.036A1.143,1.143,0,0,1,266.259,561.036ZM114.281,139.187,266.965,558.378l315.2-114.765L429.386,24.422Z",
    transform: "translate(0 0)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2002",
    "data-name": "Rect\\xE1ngulo 2002",
    width: 92.57,
    height: 111.78,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 169.907, 159.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9855",
    "data-name": "Trazado 9855",
    d: "M224.834,67.739l38.271,105-87.033,31.685-38.247-105,87.033-31.685m0-2.352a2.32,2.32,0,0,0-.8.141L137.025,97.213a2.245,2.245,0,0,0-1.341,3.034l38.271,105.074a2.353,2.353,0,0,0,2.211,1.529,2.32,2.32,0,0,0,.8-.141L264,175.025a2.351,2.351,0,0,0,1.411-3.011L227.045,66.892a2.351,2.351,0,0,0-2.211-1.552Z",
    transform: "translate(32.322 58.981)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_27",
    "data-name": "L\\xEDnea 27",
    y1: 23.616,
    x2: 64.851,
    transform: "translate(298.155 105.856)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9856",
    "data-name": "Trazado 9856",
    d: "M191.719,82.918a1.2,1.2,0,0,1-.423-2.352h0l64.851-23.522a1.18,1.18,0,1,1,.823,2.211L192.119,82.918Z",
    transform: "translate(106.436 47.66)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_28",
    "data-name": "L\\xEDnea 28",
    y1: 33.802,
    x2: 92.748,
    transform: "translate(307.117 120.299)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9857",
    "data-name": "Trazado 9857",
    d: "M195.4,99.284a1.2,1.2,0,0,1-1.106-.776,1.152,1.152,0,0,1,.661-1.489L195,97l92.8-33.8a1.18,1.18,0,0,1,.823,2.211L195.8,99.213A1.165,1.165,0,0,1,195.4,99.284Z",
    transform: "translate(111.718 55.993)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_29",
    "data-name": "L\\xEDnea 29",
    y1: 15.266,
    x2: 41.87,
    transform: "translate(316.079 163.462)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9858",
    "data-name": "Trazado 9858",
    d: "M199.206,99.128a1.224,1.224,0,0,1-1.106-.776,1.176,1.176,0,0,1,.706-1.505l41.87-15.266a1.176,1.176,0,0,1,1.505.706,1.152,1.152,0,0,1-.661,1.489l-.045.016-41.87,15.266A1.1,1.1,0,0,1,199.206,99.128Z",
    transform: "translate(116.873 80.847)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_30",
    "data-name": "L\\xEDnea 30",
    y1: 15.242,
    x2: 41.87,
    transform: "translate(374.368 142.245)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9859",
    "data-name": "Trazado 9859",
    d: "M223.986,90.049a1.153,1.153,0,0,1-1.106-.776,1.176,1.176,0,0,1,.706-1.505l41.87-15.242a1.176,1.176,0,0,1,.8,2.211l-41.87,15.242A1.164,1.164,0,0,1,223.986,90.049Z",
    transform: "translate(150.382 68.615)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9860",
    "data-name": "Trazado 9860",
    d: "M203.159,114.355a1.2,1.2,0,1,1-.423-2.352L267.587,88.48a1.176,1.176,0,0,1,1.505.706,1.152,1.152,0,0,1-.652,1.494l-.031.012-64.851,23.522Z",
    transform: "translate(121.906 90.177)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9861",
    "data-name": "Trazado 9861",
    d: "M176.2,146.877a1.13,1.13,0,0,1-1.106-.776,1.176,1.176,0,0,1,.706-1.505l64.028-23.311a1.176,1.176,0,0,1,.8,2.211L176.6,146.806Z",
    transform: "translate(85.758 134.55)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2003",
    "data-name": "Rect\\xE1ngulo 2003",
    width: 30.579,
    height: 24.463,
    transform: "translate(229.926 322.618) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9862",
    "data-name": "Trazado 9862",
    d: "M170.96,180.491a1.246,1.246,0,0,1-.494,0,1.294,1.294,0,0,1-.612-.659l-8.374-23a1.176,1.176,0,0,1,.706-1.505l28.838-10.561a1.176,1.176,0,0,1,.894,0,1.294,1.294,0,0,1,.612.659L200.9,168.4a1.176,1.176,0,0,1-.706,1.505l-28.744,10.467A1.091,1.091,0,0,1,170.96,180.491Zm-6.869-23.522,7.574,20.77,26.533-9.644L190.625,147.3Z",
    transform: "translate(67.355 166.257)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2004",
    "data-name": "Rect\\xE1ngulo 2004",
    width: 30.579,
    height: 24.463,
    transform: "translate(214.225 281.436) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9863",
    "data-name": "Trazado 9863",
    d: "M164.28,162.981a1.224,1.224,0,0,1-1.106-.776L154.8,139.223a1.176,1.176,0,0,1,.706-1.505L184.25,127.25a1.176,1.176,0,0,1,1.505.706l8.374,22.981a1.176,1.176,0,0,1-.706,1.505l-28.65,10.467A1.108,1.108,0,0,1,164.28,162.981Zm-6.869-23.522,7.574,20.794,26.533-9.668-7.574-20.77Z",
    transform: "translate(58.322 142.603)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9864",
    "data-name": "Trazado 9864",
    d: "M182.166,163.306a1.224,1.224,0,0,1-1.106-.776,1.176,1.176,0,0,1,.706-1.505l64.028-23.334a1.176,1.176,0,0,1,1.505.706,1.152,1.152,0,0,1-.661,1.489l-.045.016-64.028,23.334A1.1,1.1,0,0,1,182.166,163.306Z",
    transform: "translate(93.831 156.72)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2005",
    "data-name": "Rect\\xE1ngulo 2005",
    width: 30.579,
    height: 24.463,
    transform: "translate(350.11 235.144) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9865",
    "data-name": "Trazado 9865",
    d: "M222.065,143.3a1.176,1.176,0,0,1-1.106-.776l-8.374-22.981a1.078,1.078,0,0,1,0-.894,1.061,1.061,0,0,1,.659-.612l28.674-10.467a1.176,1.176,0,0,1,1.505.706l8.374,22.981a1.152,1.152,0,0,1-.661,1.489l-.045.016L222.371,143.23ZM215.2,119.779l7.574,20.77,26.51-9.668-7.574-20.77Z",
    transform: "translate(136.425 115.991)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9866",
    "data-name": "Trazado 9866",
    d: "M233.256,126.1a1.13,1.13,0,0,1-1.106-.776,1.176,1.176,0,0,1,.706-1.505L296.884,100.5a1.176,1.176,0,0,1,.8,2.211l-64.028,23.311Z",
    transform: "translate(162.917 106.45)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2006",
    "data-name": "Rect\\xE1ngulo 2006",
    width: 30.579,
    height: 24.463,
    transform: "translate(364.156 273.738) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9867",
    "data-name": "Trazado 9867",
    d: "M228.02,159.7a1.176,1.176,0,0,1-1.106-.776l-8.374-23.028a1.176,1.176,0,0,1,.706-1.505l28.7-10.42a1.2,1.2,0,0,1,1.505.706l8.374,22.981a1.176,1.176,0,0,1,0,.894,1.191,1.191,0,0,1-.659.612L228.42,159.627A1.1,1.1,0,0,1,228.02,159.7Zm-6.868-23.522,7.574,20.77,26.51-9.644-7.551-20.817Z",
    transform: "translate(144.513 138.171)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9868",
    "data-name": "Trazado 9868",
    d: "M239.222,142.5a1.153,1.153,0,0,1-1.106-.776,1.2,1.2,0,0,1,.706-1.505L302.85,116.9a1.176,1.176,0,0,1,.8,2.211l-64.028,23.311A1.1,1.1,0,0,1,239.222,142.5Z",
    transform: "translate(170.993 128.627)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9869",
    "data-name": "Trazado 9869",
    d: "M253.231,230.94a1.193,1.193,0,0,1-.4-2.352L349.7,193.3a1.176,1.176,0,0,1,.8,2.211L253.631,230.8Z",
    transform: "translate(189.634 231.937)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9870",
    "data-name": "Trazado 9870",
    d: "M185.851,265.281a1.193,1.193,0,1,1-.4-2.352l240.21-87.385a1.18,1.18,0,1,1,.823,2.211L186.251,265.21Z",
    transform: "translate(98.52 207.9)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9871",
    "data-name": "Trazado 9871",
    d: "M181.864,255.455a1.193,1.193,0,1,1-.4-2.352l240.21-87.385a1.18,1.18,0,0,1,.823,2.211L182.264,255.384Z",
    transform: "translate(93.129 194.613)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9872",
    "data-name": "Trazado 9872",
    d: "M177.914,244.867a1.193,1.193,0,1,1-.4-2.352l240.21-87.385a1.18,1.18,0,1,1,.823,2.211L178.314,244.8Z",
    transform: "translate(87.788 180.297)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9873",
    "data-name": "Trazado 9873",
    d: "M235.083,99.976l11.055,30.344L159.105,162l-11.055-30.32c5.763-11.549,17.336-18.982,27.78-23.875,4-1.882,7.856-3.364,11.15-4.563l.776-.282c3.058-1.106,6.633-2.352,10.514-3.34h.212C209.631,96.589,223.2,94.966,235.083,99.976Z",
    transform: "translate(49.289 101.474)",
    fill: "#27dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9874",
    "data-name": "Trazado 9874",
    d: "M183.8,100.39h0l2.117,31.332.612,9.174-1.952.706-5.434-7.433L160.68,108.882h0A58.262,58.262,0,0,1,183.8,100.39Z",
    transform: "translate(66.367 106.377)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9875",
    "data-name": "Trazado 9875",
    d: "M166.458,91.174c-1.317-6.8,8.8-12.279,11.032-4.493a11.994,11.994,0,0,1-.188,8.256,7.056,7.056,0,0,1-6.563,4.281",
    transform: "translate(74.021 82.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9876",
    "data-name": "Trazado 9876",
    d: "M171.726,101.031h-.47a1.2,1.2,0,0,1-1.106-1.287v-.007a1.223,1.223,0,0,1,1.294-1.129,5.813,5.813,0,0,0,5.363-3.575,10.84,10.84,0,0,0,.188-7.315c-.894-3.1-2.987-3.081-4.163-2.823a6.141,6.141,0,0,0-4.516,6.774,1.175,1.175,0,0,1-.894,1.4l-.047.009a1.222,1.222,0,0,1-1.435-.964,8.517,8.517,0,0,1,6.328-9.574,5.74,5.74,0,0,1,6.977,4.149c.031.122.056.245.08.367a13.09,13.09,0,0,1-.306,8.986A8.324,8.324,0,0,1,171.726,101.031Z",
    transform: "translate(73.34 82.002)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9877",
    "data-name": "Trazado 9877",
    d: "M161.931,92.528c-3.364-6.069-14.631-3.764-11.338,3.622a11.876,11.876,0,0,0,5.434,6.092,7.057,7.057,0,0,0,7.786-.941",
    transform: "translate(51.921 91.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9878",
    "data-name": "Trazado 9878",
    d: "M160.1,104.933a8.868,8.868,0,0,1-3.834-.87,13.106,13.106,0,0,1-6.022-6.7,5.69,5.69,0,0,1,2.105-7.769q.191-.109.388-.2a8.491,8.491,0,0,1,11.008,3.27,1.211,1.211,0,1,1-2.117,1.176,6.116,6.116,0,0,0-7.809-2.352,3.27,3.27,0,0,0-1.557,4.354,3.388,3.388,0,0,0,.193.35,10.965,10.965,0,0,0,4.846,5.5,5.857,5.857,0,0,0,6.422-.729,1.221,1.221,0,0,1,1.717,0,1.2,1.2,0,0,1,0,1.694A7.622,7.622,0,0,1,160.1,104.933Z",
    transform: "translate(51.234 90.331)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9879",
    "data-name": "Trazado 9879",
    d: "M165.18,122.864a13.076,13.076,0,0,0,13.643,2.164,14.491,14.491,0,0,0,9.55-10.609L178.235,90.05,157.3,97.671Z",
    transform: "translate(61.797 92.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9880",
    "data-name": "Trazado 9880",
    d: "M174.27,127.862a13.5,13.5,0,0,1-9.244-3.5,1.331,1.331,0,0,1-.306-.494l-7.88-25.145a1.2,1.2,0,0,1,.753-1.482l20.864-7.621a1.225,1.225,0,0,1,1.552.659L190.218,114.6a1.554,1.554,0,0,1,0,.659,15.668,15.668,0,0,1-10.35,11.573A16.432,16.432,0,0,1,174.27,127.862Zm-7.315-5.034a11.879,11.879,0,0,0,12.138,1.717,13.365,13.365,0,0,0,8.7-9.409l-9.55-22.911-18.818,6.845Z",
    transform: "translate(61.104 91.701)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9881",
    "data-name": "Trazado 9881",
    d: "M159.529,102.631a18.242,18.242,0,0,0,8.35,3.246c4.987.776,12.114,1.106,16.865-1.505l-4.7-10.162a49.592,49.592,0,0,1-10.961,4.21,33.976,33.976,0,0,1-10.232,1.647C158.188,99.926,158.517,101.855,159.529,102.631Z",
    transform: "translate(63.426 98.02)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9882",
    "data-name": "Trazado 9882",
    d: "M175.39,108.24a47.264,47.264,0,0,1-7.057-.565,19.087,19.087,0,0,1-8.868-3.481,3.809,3.809,0,0,1-1.364-3.811,1.387,1.387,0,0,1,1.411-.941,32.4,32.4,0,0,0,9.856-1.6,48.177,48.177,0,0,0,10.844-4.022,1.237,1.237,0,0,1,.917,0,1.125,1.125,0,0,1,.682.635l4.7,10.138a1.177,1.177,0,0,1-.494,1.529A22.555,22.555,0,0,1,175.39,108.24Zm-14.866-6.445a1.648,1.648,0,0,0,.4.565h0a17.164,17.164,0,0,0,7.809,3.011c2.964.447,10.138,1.247,15.148-.894l-3.669-8.021A51.706,51.706,0,0,1,170,100.1a37.332,37.332,0,0,1-9.479,1.694Zm-1.129,0",
    transform: "translate(62.76 97.374)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9883",
    "data-name": "Trazado 9883",
    d: "M179.867,123.576l1.717-.635A15.689,15.689,0,0,0,191,102.851l-.007-.021-8.515-23.358A23.875,23.875,0,0,0,151.24,90.645l8.492,23.522a15.714,15.714,0,0,0,20.13,9.411Z",
    transform: "translate(53.602 75.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9884",
    "data-name": "Trazado 9884",
    d: "M174.494,78.688a19.667,19.667,0,0,1,9.409,2.188l8.515,23.358a15.69,15.69,0,0,1-9.388,20.1l-.021.007-1.717.635a16.046,16.046,0,0,1-5.387.941,15.714,15.714,0,0,1-14.725-10.256l-8.492-23.522a21.883,21.883,0,0,1,13.314-12,24.519,24.519,0,0,1,8.492-1.552m0-2.352a27.108,27.108,0,0,0-9.409,1.694,24.249,24.249,0,0,0-14.772,13.5,2.349,2.349,0,0,0,0,1.623l8.492,23.358a18.087,18.087,0,0,0,23.167,10.846l.073-.026,1.717-.635a18.136,18.136,0,0,0,10.844-23.24l-8.515-23.334a2.342,2.342,0,0,0-1.035-1.27A22.209,22.209,0,0,0,174.4,76.242Z",
    transform: "translate(52.153 73.718)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9885",
    "data-name": "Trazado 9885",
    d: "M164.874,138.771a1.2,1.2,0,0,1-1.082-.682l-11.9-24.534a1.223,1.223,0,0,1,2.188-1.059l11.879,24.534a1.2,1.2,0,0,1-.536,1.609l-.028.014A1.27,1.27,0,0,1,164.874,138.771Z",
    transform: "translate(54.387 121.98)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9886",
    "data-name": "Trazado 9886",
    d: "M189.671,129.728a1.175,1.175,0,0,1-1.176-.917l-6.68-26.439a1.223,1.223,0,0,1,2.352-.588l6.68,26.439a1.223,1.223,0,0,1-.894,1.482h0Z",
    transform: "translate(94.936 107.217)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9887",
    "data-name": "Trazado 9887",
    d: "M160.927,115.453c-2.235-7.315-6.022-16.207-4.822-18.112s2.658,0,3.858-2.164.188-2.352.188-2.352a28.2,28.2,0,0,1,8.045-4.54c2.776-.47,9.409-.894,11.9-4.422,0,0,6.351,3.834,7.645,6.869s3.552,11.761,4.14,11.408,1.764-8.28,1.529-11.761a14.773,14.773,0,0,0-12.373-13.267s-.917-3.858-10.491-2.917-17.783,7.362-19.571,11.126a28.637,28.637,0,0,0-.894,16.936c1.388,4.187,2.987,4.14,2.987,4.14Z",
    transform: "translate(50.854 70.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9888",
    "data-name": "Trazado 9888",
    d: "M161.623,117.424a1.172,1.172,0,0,1-.917-.423l-7.621-8.915c-.87-.306-2.352-1.388-3.458-4.869a29.9,29.9,0,0,1,.941-17.83c2-4.21,10.467-10.82,20.558-11.761,8.068-.776,10.656,1.67,11.455,3.034A15.973,15.973,0,0,1,195.33,90.938c0,1.882-.47,12-2.141,12.961a1.3,1.3,0,0,1-1.106,0c-.847-.329-1.176-1.059-2.917-6.633-.659-2.093-1.341-4.258-1.858-5.434a19.969,19.969,0,0,0-6.28-5.763c-2.752,2.729-7.6,3.411-10.609,3.834l-1.341.212a22.717,22.717,0,0,0-6.657,3.669,4.417,4.417,0,0,1-.706,2.705,3.152,3.152,0,0,1-3.011,1.811c-.565,0-.659,0-.894.4-.47,1.082,1.529,6.916,2.87,10.773.729,2.117,1.482,4.281,2.094,6.351a1.2,1.2,0,0,1-.565,1.411A1.267,1.267,0,0,1,161.623,117.424Zm-7.692-11.761a.943.943,0,0,1,.753.423l3.834,4.493-.141-.4c-2.47-7.2-3.717-11.032-2.611-12.82a3.058,3.058,0,0,1,2.846-1.552c.588,0,.682,0,.964-.565a4.12,4.12,0,0,0,.423-.988,1.382,1.382,0,0,1-.353-.635,1.294,1.294,0,0,1,.447-1.2,28.788,28.788,0,0,1,8.586-4.7l1.411-.212c2.917-.4,7.809-1.106,9.715-3.717a1.2,1.2,0,0,1,1.6-.329c.706.4,6.727,4.116,8.139,7.41.541,1.294,1.247,3.528,1.929,5.669.259.8.541,1.694.823,2.54a47.521,47.521,0,0,0,.612-8.068,13.571,13.571,0,0,0-11.385-12.185,1.2,1.2,0,0,1-.964-.917h0s-1.082-2.776-9.2-1.976c-9.409.917-17.1,7.292-18.583,10.467a27.318,27.318,0,0,0-.87,16c1.011,3.011,2,3.34,2,3.34Z",
    transform: "translate(50.159 69.984)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9889",
    "data-name": "Trazado 9889",
    d: "M138.35,244.6c12.867-21.17,29.45-53.7,40.247-75.906,5.293-10.891,24.793-4.846,26.2,4.4,1.952,12.937-20.817,79.552-20.958,79.388a70.567,70.567,0,0,1,7.574,77.506",
    transform: "translate(36.172 190.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9890",
    "data-name": "Trazado 9890",
    d: "M192.137,331.873a1.047,1.047,0,0,1-.565-.165,1.154,1.154,0,0,1-.468-1.562l.021-.038a69.839,69.839,0,0,0-7.48-76.189,1.178,1.178,0,0,1-.188-1.176v-.165c1.294-3.058,22.676-66.451,20.817-78.612-.635-4.14-5.928-8.115-12.091-9.056-5.5-.823-9.95,1.035-11.879,4.987-5.575,11.432-24.934,50.761-40.294,76a1.176,1.176,0,0,1-1.621.379l0,0a1.153,1.153,0,0,1-.414-1.576l.014-.024c15.313-25.145,34.648-64.381,40.2-75.812,2.352-4.94,7.762-7.292,14.349-6.28,6.139.941,13.172,5.128,14.113,11.032,1.694,11.15-16.466,69.6-20.817,79.27a71.341,71.341,0,0,1,7.315,78.376A1.2,1.2,0,0,1,192.137,331.873Z",
    transform: "translate(35.452 190.163)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1234",
    "data-name": "Elipse 1234",
    cx: 5.104,
    cy: 5.104,
    r: 5.104,
    transform: "translate(238.55 548.969)",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificados);
export default __webpack_public_path__ + "static/media/Certificados.9f2c0c4309d104a4d2e4581a1ca2d9e5.svg";
export { ForwardRef as ReactComponent };